<template>
  <router-view module="call-center" />
</template>

<script>
export default {
  name: "ProspectsCallCenter"
};
</script>
